import script from "./BrandLogin.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrandLogin.vue?vue&type=script&lang=ts&setup=true"

import "./BrandLogin.vue?vue&type=style&index=0&id=8bc796f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bc796f0"]])

export default __exports__